import React from "react";
import { connect } from "react-redux";
import { DISPLAY_COMPANY_PROFILE_POPUP } from "../../common/constants";
import { showAlert } from "../../utility/alertHelper";
import { apiCall } from "../../utility/apiCall";
import Session from "../../utility/session";
import ProfilePopup from "./companyProfilePopup";
import logo from "../../images/clean-your-lists-transparent-logo.png";

class CompanyProfile extends React.Component {
  state = {
    defaultQuestions: [
      "How many Emails you might be validating per month?",
      "Which Email tool you are using to send Emails?",
    ],
    showPopup: false,
    response: {},
    profileInfo: {},
    erroredIndexes: [],
  };
  async componentWillMount() {
    let token = new URLSearchParams(window.location.search).get("token");
    let response = await apiCall(`api/company/validate-token?token=${token}`);
    if (!response.success) {
      showAlert({
        msg_code: "",
        msg_type: "error",
        msg_text: response.msg,
      });
    } else if (!response.validated) {
      showAlert({
        msg_code: "",
        msg_type: "error",
        msg_text: response.msg,
      });
      if (response.profileUpdated == false && Number(response.time) <= 0) {
        this.setState({ showPopup: true, response });
      } else {
        this.props.history.push("/email-verification");
      }
    }
  }
  onResendActivation = async () => {
    let resp = await apiCall("api/company/resend-activation");
    if (resp.success) {
      this.props.dispatch({ type: DISPLAY_COMPANY_PROFILE_POPUP });
      this.setState({ showPopup: false });
      showAlert({
        msg_text: `We have resent the activation Email.`,
        msg_type: "success",
      });
      this.props.history.push("/email-verification");
    } else {
      showAlert({
        msg_text: `Something went wrong. Please try again.`,
        msg_type: "error",
      });
    }
  };
  onClickedOK = () => {
    this.props.dispatch({ type: DISPLAY_COMPANY_PROFILE_POPUP });
    this.setState({ showPopup: false });
    this.props.history.push("/email-verification");
  };
  onChange = (question, answer) => {
    this.setState({
      profileInfo: { ...this.state.profileInfo, [question]: answer },
    });
  };
  onSubmit = async (e) => {
    e.preventDefault();
    let profileInfo = Object.keys(this.state.profileInfo).reduce(
      (p, c) => [
        ...p,
        { question: c, answer: this.state.profileInfo[c].trim() },
      ],
      []
    );
    if (!profileInfo.length) {
      showAlert({ msg_type: "error", msg_text: "All fields are mandatory." });
      // this.setState({ erroredIndexes: this.state.defaultQuestions })
    } else {
      let erroredIndexes = profileInfo.map(v => v.answer)
      .filter(answer => (!answer || !answer.trim().length))
        // .map((v, index) => {
        //   if (!v.answer.trim().length) {
        //     return v.question;
        //   }
        // })
        // .filter((v) => !!v);
      // this.setState({ erroredIndexes })
      if (profileInfo.length && !erroredIndexes.length && (profileInfo.length == this.state.defaultQuestions.length)) {
        let response = await apiCall("api/company/profile-info", "POST", {
          profileInfo,
          token: new URLSearchParams(window.location.search).get("token")
        });
        if (response.success) {
          showAlert({
            msg_code: "",
            msg_type: "success",
            msg_text: "Profile updated successfully.",
          });
          this.props.history.push("/email-verification");
        } else {
          showAlert({
            msg_code: "",
            msg_type: "error",
            msg_text: "Failed to save profile info.",
          });
        }
      } else {
        showAlert({ msg_type: "error", msg_text: "All fields are mandatory." });
      }
    }
  };
  render() {
    const { response } = this.state;
    return (
      <div
        className="row row-flex full-height"
        style={{ marginRight: 0, marginLeft: 0, background: "#f7f7f7" }}
      >
        <div
          className="col-md-12 col-sm-12 col-xs-12"
          style={{ background: "#fff", marginLeft:210, marginRight:210 }}
        >
          <div>
            <div class="x_content" style={{paddingTop:40}}>
              {this.state.showPopup && Number(response.time) <= 0 ? (
                <ProfilePopup
                  onResendActivation={this.onResendActivation}
                  onOKClick={this.onClickedOK}
                  timeLapse={response.timeLapsed}
                  timer={response.time}
                />
              ) : (
                <div>
                  <div className="text-center" style={{paddingTop:25}}>
                    <h1>
                      <a href="https://cleanyourlists.com/" target="_blank">
                      <img src={logo} alt="logo" width="320" />
                      </a>
                    </h1>
                  </div>
                  <div className="col-md-8 col-md-offset-2">
                    <p>Hi {Session.getItem(Session.CURRENT_NAME)},</p>
                    <p>
                      Thank you for utilizing your first set of free credits. You are just one step away from unlocking your remaining free credits. Please provide us some details to help us serve you better.
                    </p>
                  </div>
                  <div style={{ paddingTop: 25 }}>
                    <form
                      className="form-horizontal form-label-left"
                      // onSubmit={this.onSubmit}
                    >
                      {this.state.defaultQuestions.map((question, index) => (
                        <div>
                          <div className="col-md-8 col-md-offset-2" style={{marginBottom:5}}>
                            <label>
                              <span
                                className="required-label"
                                style={{ marginRight: 5 }}
                              >
                                *
                              </span>
                              {question}
                            </label>
                            <input
                              id={`q${index}`}
                              className="form-control col-md-7 col-xs-12"
                              data-validate-length-range="6"
                              data-validate-words="2"
                              name={`q${index}`}
                              required
                              type="text"
                              value={this.state.profileInfo[question]}
                              onChange={(e) =>
                                this.onChange(question, e.target.value)
                              }
                            />
                          </div>
                        </div>
                      ))}
                      <div className="form-group">
                        <div className="col-md-8 col-md-offset-2" style={{marginTop:15}}>
                          <input
                            type="submit"
                            style={{ width: "25%", height: 40, marginLeft:200 }}
                            id="btnSave"
                            type="submit"
                            className="btn btn-primary btn-md"
                            onClick={this.onSubmit}
                            value="Save"
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      // <div>
      // <div class="right_col" role="main">
      //   <div class="">
      //     <div class="page-title">
      //       <div class="title_right"></div>
      //       <div class="clearfix"></div>
      //       <div class="row">
      //         <div class="col-md-12 col-sm-12 col-xs-12">
      //           {/* <div class="x_panel"> */}
      //             <div class="x_title">
      //               <ul class="nav navbar-right panel_toolbox">
      //                 <li></li>
      //               </ul>
      //               <div class="clearfix"></div>
      //             </div>
      //             <div class="x_content">
      //               {this.state.showPopup && Number(response.time) <= 0 ? (
      //                 <ProfilePopup
      //                   onResendActivation={this.onResendActivation}
      //                   onOKClick={this.onClickedOK}
      //                   timeLapse={response.timeLapsed}
      //                   timer={response.time}
      //                 />
      //               ) : (
      //                 <div>
      //                 <div>
      //                   <p>Hi {Session.getItem(Session.CURRENT_NAME)},</p>
      //                   <p>Thank you for utilizing your first set of free credits. Provide us some details so that we can serve you better.</p>
      //                 </div>
      //                 <div style={{paddingTop:25}}>
      //                 <form
      //                   className="form-horizontal form-label-left"
      //                   // onSubmit={this.onSubmit}
      //                 >
      //                   {this.state.defaultQuestions.map((question,index) =>
      //                     <div className="item form-group" style={{paddingBottom:15}}>
      //                       <label
      //                         className="control-label col-md-3 col-sm-3 col-xs-12"></label>
      //                       <div className="col-md-6 col-sm-6 col-xs-12">
      //                         <label>
      //                           <span className="required-label" style={{marginRight:5}}>*</span>
      //                           {question}
      //                         </label>
      //                         <input
      //                           id={`q${index}`}
      //                           className="form-control col-md-7 col-xs-12"
      //                           data-validate-length-range="6"
      //                           data-validate-words="2"
      //                           name={`q${index}`}
      //                           maxLength="50"
      //                           required
      //                           type="text"
      //                           value={this.state.profileInfo[question]}
      //                           onChange={e => this.onChange(question, e.target.value)}
      //                         />
      //                       </div>
      //                     </div>
      //                   )}
      //                  <div className="form-group">
      //                     <div className="col-md-6 col-md-offset-3">
      //                       <button
      //                         style={{ width: "48%", height:35, marginRight: "4%" }}
      //                         type="clear"
      //                         className="btn btn-default btn-md"
      //                         onClick={this.handleCancel}
      //                       >
      //                         Cancel
      //                       </button>
      //                       <input type="submit"
      //                         style={{ width: "48%", height:35 }}
      //                         id="btnSave"
      //                         type="submit"
      //                         className="btn btn-primary btn-md"
      //                         onClick={this.onSubmit}
      //                         value="Save"
      //                       />
      //                     </div>
      //                   </div>
      //                 </form>
      //                 </div>
      //                 </div>
      //               )}
      //             </div>
      //           {/* </div> */}
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // </div>
      // </div>
    );
  }
}
const mapStateToProps = ({ emailverificationinfo }) => ({
  showCompanyProfilePopup: emailverificationinfo.showCompanyProfilePopup,
});
export default connect(mapStateToProps)(CompanyProfile);



// WEBPACK FOOTER //
// ./src/components/Login/companyProfile.js